import React from "react";
import useMousePosition from "../hooks/useMousePosition";
import MainStore from "../stores/MainStore";

const PointCursor = () => {
  const { x, y } = useMousePosition();
  const { pointCursor } = MainStore();
  return (
    <div
      style={{
        left: `${x}px`,
        top: `${y}px`,
        cursor: "pointer",
        position: "absolute",
        transform: "translate(-50%, -50%)",
        zIndex: 999999,
        pointerEvents: "none",
      }}
    >
      {pointCursor && (
        <img src={"/icons/icon_point.png"} className="icon25" style={{}} />
      )}
    </div>
  );
};

export default PointCursor;
